import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "token-dashboard" */ './TokensDashboardCtnr'));
